(function(angular) {
    'use strict';

    var exportManager = function(dmsHttp:any) {
        var factory:any = {};
        var exportRequestMethod = 'export';

        factory.exportDocuments = function(exportRequest:any) {
            var config = dmsHttp.getAnonymousHttpPostConfig(exportRequestMethod, exportRequest);
            return dmsHttp.makeHttpRequest(config);
        };

        factory.checkProgress = function(transactionId:any, site:any) {
            var config = dmsHttp.getAnonymousHttpGetConfig(exportRequestMethod + '/' + transactionId + '/' + 'progress?site=' + site);
            return dmsHttp.makeHttpRequest(config);
        };

        return factory;
    };

    exportManager.$inject = ['dmsHttp'];
    angular.module('onvio.documents').factory('exportManager', exportManager);
})((window as any).angular);
